<script setup lang="ts">
import type { TutorTask } from '../model/tutor-tasks/interfaces'

import { faClock, faPenToSquare, faTrashCan, faXmark } from '@fortawesome/pro-regular-svg-icons'

import { AppDropdown, AppDropdownItem } from '@shared/ui/dropdowns'
import { BtnIcon } from '@shared/ui/buttons'

import { useDisciplineTaskActions } from '../model/discipline-task-actions.hook'

defineOptions({
  name: 'DisciplineTaskActions',
})

const props = withDefaults(defineProps<{
  task: TutorTask
  shortcuts?: boolean
}>(), {
  shortcuts: false,
})

const {
  isOpen,
  containerRef,
  floatingRef,
  floatingStyles,
  triggerIcon,
  canManageTutorTasks,
  refIsTaskOpen,
  toggle,
  openEdit,
  openPostpone,
  openCancel,
  openDelete,
} = useDisciplineTaskActions({
  task: computed(() => props.task),
})
</script>

<template>
  <div
    ref="containerRef"
    class="discipline-task-actions"
  >
    <BtnIcon
      :icon="triggerIcon"
      view="table"
      :title="`Actions for task ${task.id}`"
      @click="toggle"
    />
    <div
      v-if="isOpen"
      ref="floatingRef"
      class="discipline-task-actions__floating"
      :style="floatingStyles"
    >
      <AppDropdown>
        <AppDropdownItem
          v-if="!shortcuts"
          text="Edit task"
          color="blue"
          :prepend-icon="faPenToSquare"
          @click="openEdit"
        />
        <AppDropdownItem
          v-if="canManageTutorTasks && refIsTaskOpen"
          text="Postpone task"
          color="blue"
          :prepend-icon="faClock"
          @click="openPostpone"
        />
        <AppDropdownItem
          v-if="canManageTutorTasks && refIsTaskOpen"
          text="Cancel task"
          color="red"
          :prepend-icon="faXmark"
          @click="openCancel"
        />
        <AppDropdownItem
          v-if="canManageTutorTasks && !shortcuts"
          text="Delete task"
          color="red"
          :prepend-icon="faTrashCan"
          @click="openDelete"
        />
      </AppDropdown>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./DisciplineTaskActions.scss" />
